// extracted by mini-css-extract-plugin
export default {"cta":"ZG-z","disabled":"_G-z"};